//resolution
const ELLEVIO_CHART_RESOLUTION_YEARLY = 'Yearly'
const ELLEVIO_CHART_RESOLUTION_MONTHLY = 'Monthly'
const ELLEVIO_CHART_RESOLUTION_WEEKLY = 'Weekly'
const ELLEVIO_CHART_RESOLUTION_DAILY = 'Daily'
const ELLEVIO_CHART_RESOLUTION_HOURLY = 'Hourly'
const ELLEVIO_CHART_INTERVAL_ALL = 'All'

export default {
  ELLEVIO_CHART_RESOLUTION_YEARLY,
  ELLEVIO_CHART_RESOLUTION_MONTHLY,
  ELLEVIO_CHART_RESOLUTION_WEEKLY,
  ELLEVIO_CHART_RESOLUTION_DAILY,
  ELLEVIO_CHART_RESOLUTION_HOURLY
}

const YEARLY = 'Yearly'
const MONTHLY = 'Monthly'
const WEEKLY = 'Weekly'
const DAILY = 'Daily'
const HOURLY = 'Hourly'
const QUARTERLY = 'QuarterHourly'

export const intervals = {
  YEARLY,
  MONTHLY,
  WEEKLY,
  DAILY,
  HOURLY,
  QUARTERLY
}

export const resolutions = {
  MONTHLY,
  WEEKLY,
  DAILY,
  HOURLY,
  QUARTERLY
}

export const resolutionArrays = {
  YEARLY: [
    {
      value: intervals.MONTHLY,
      displayName: 'Månad',
      disabled: false,
      selected: true
    },
    {
      value: intervals.WEEKLY,
      displayName: 'Vecka',
      disabled: false,
      selected: false
    }
  ],
  MONTHLY: [
    {
      value: intervals.DAILY,
      displayName: 'Dag',
      disabled: false,
      selected: true
    },
    {
      value: intervals.HOURLY,
      displayName: 'Timme',
      disabled: false,
      selected: false
    }
  ],
  WEEKLY: [
    {
      value: intervals.DAILY,
      number: 3,
      displayName: 'Dag',
      disabled: false,
      selected: true
    },
    {
      value: intervals.HOURLY,
      displayName: 'Timme',
      disabled: false,
      selected: false
    }
  ],
  DAILY: [
    {
      value: intervals.HOURLY,
      displayName: 'Timme',
      disabled: false,
      selected: true
    },
    {
      value: intervals.QUARTERLY,
      displayName: '15-minuter',
      disabled: false,
      selected: false
    }
  ]
}

//TODO: look for better way that uses translations
export const resolutionArray = [ELLEVIO_CHART_RESOLUTION_YEARLY, ELLEVIO_CHART_RESOLUTION_MONTHLY, ELLEVIO_CHART_RESOLUTION_WEEKLY, ELLEVIO_CHART_RESOLUTION_DAILY, ELLEVIO_CHART_RESOLUTION_HOURLY]
export const intervalArray = [ELLEVIO_CHART_INTERVAL_ALL, ELLEVIO_CHART_RESOLUTION_YEARLY, ELLEVIO_CHART_RESOLUTION_MONTHLY, ELLEVIO_CHART_RESOLUTION_WEEKLY, ELLEVIO_CHART_RESOLUTION_DAILY]

export const resolutionLevel = (res) => {
  if (res === ELLEVIO_CHART_RESOLUTION_YEARLY) {
    return 0
  } else if (res === ELLEVIO_CHART_RESOLUTION_MONTHLY) {
    return 1
  } else if (res === ELLEVIO_CHART_RESOLUTION_WEEKLY) {
    return 2
  } else if (res === ELLEVIO_CHART_RESOLUTION_DAILY) {
    return 3
  } else if (res === ELLEVIO_CHART_RESOLUTION_HOURLY) {
    return 4
  } else {
    return -1
  }
}
